import { jsx, jsxs, Fragment } from "react/jsx-runtime";
import isEqual from "lodash.isequal";
import CellContainer from "../CellContainer.js";
import { Label, ValueRemoved, ValueRequiresDecisionPills, ValueAddedPills } from "../Styles.js";
import { Pills } from "./Pills.js";
const EMPTY = {};
const getValueIsEmpty = (value) => {
  return !Array.isArray(value) || !value.length;
};
const Renderer = (props) => {
  var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l, _m, _n;
  const value = (_a = props.cell) == null ? void 0 : _a.value;
  const diffValue = (_b = props.cell) == null ? void 0 : _b.diffValue;
  const isDiffView = props.isDiffView && !isEqual(value, diffValue);
  const isValueEmpty = getValueIsEmpty(value);
  const isDiffValueEmpty = getValueIsEmpty(diffValue);
  const isContentEmpty = isValueEmpty && isDiffValueEmpty;
  const unresolvedDecision = ((_d = (_c = props.cell) == null ? void 0 : _c.metadata) == null ? void 0 : _d.requiresDecision) && !((_f = (_e = props.cell) == null ? void 0 : _e.metadata) == null ? void 0 : _f.acceptedValue);
  const acceptedValue = (_h = (_g = props.cell) == null ? void 0 : _g.metadata) == null ? void 0 : _h.acceptedValue;
  return /* @__PURE__ */ jsx(
    CellContainer,
    {
      ...props,
      innerStatus: isContentEmpty ? props.status : EMPTY,
      dropdown: true,
      children: isContentEmpty ? /* @__PURE__ */ jsx(Label, {}) : !isDiffView ? ((_j = (_i = props.cell) == null ? void 0 : _i.config) == null ? void 0 : _j.markedForDeletion) ? /* @__PURE__ */ jsx(ValueRemoved, { children: /* @__PURE__ */ jsx(Pills, { options: value, allowRemove: false, ...props.status }) }) : /* @__PURE__ */ jsx(Pills, { options: value, allowRemove: false, ...props.status }) : /* @__PURE__ */ jsxs(Fragment, { children: [
        !isValueEmpty && /* @__PURE__ */ jsxs(Fragment, { children: [
          unresolvedDecision && /* @__PURE__ */ jsx(ValueRequiresDecisionPills, { children: /* @__PURE__ */ jsx(Pills, { options: value, allowRemove: false }) }),
          !unresolvedDecision && /* @__PURE__ */ jsx(Fragment, { children: acceptedValue === "source" && !((_l = (_k = props.cell) == null ? void 0 : _k.config) == null ? void 0 : _l.markedForDeletion) ? /* @__PURE__ */ jsx(ValueAddedPills, { children: /* @__PURE__ */ jsx(Pills, { options: value, allowRemove: false }) }) : /* @__PURE__ */ jsx(ValueRemoved, { children: /* @__PURE__ */ jsx(Pills, { options: value, allowRemove: false }) }) })
        ] }),
        !isDiffValueEmpty && /* @__PURE__ */ jsxs(Fragment, { children: [
          !unresolvedDecision && /* @__PURE__ */ jsx(Fragment, { children: acceptedValue === "source" || ((_n = (_m = props.cell) == null ? void 0 : _m.config) == null ? void 0 : _n.markedForDeletion) ? /* @__PURE__ */ jsx(ValueRemoved, { children: /* @__PURE__ */ jsx(Pills, { options: diffValue, allowRemove: false }) }) : /* @__PURE__ */ jsx(ValueAddedPills, { children: /* @__PURE__ */ jsx(Pills, { options: diffValue, allowRemove: false }) }) }),
          unresolvedDecision && /* @__PURE__ */ jsx(ValueRequiresDecisionPills, { children: /* @__PURE__ */ jsx(Pills, { options: diffValue, allowRemove: false }) })
        ] })
      ] })
    }
  );
};
export {
  Renderer as default
};
